<template>
  <v-container fluid style="background-color: white">
    <v-tabs v-model="selectedTab">
      <v-tab>ХИЧЭЭЛЭЭР</v-tab>
      <v-tab> СУРАЛЦАГЧААР </v-tab>
      <v-tab>НЭГТГЭЛ</v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab" style="background-color: white">
      <v-btn
        class="mt-4 bg-gradient-info"
        dark
        style="width: 22%"
        @click="_calculateSubjectAreas(true)"
      >
        Судлагдахууны дүн бодох
      </v-btn>
      <v-progress-linear
        class="mx-4 mt-4"
        v-if="loading"
        color="red"
        height="6"
        indeterminate
      ></v-progress-linear>
      <v-tab-item>
        <v-data-table
          v-if="planCourses && renderComponent"
          :headers="headers"
          :items="planCourses"
          class="elevation-1"
          dense
          hide-details
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Хичээл</v-toolbar-title>
            </v-toolbar>
          </template>
          <template v-slot:item.withGrade="{ item }">
            <span class="green--text">
              {{ item.withGrade }}
            </span>
          </template>
          <template v-slot:item.withNoGrade="{ item }">
            <span class="red--text">
              {{ item.withNoGrade }}
            </span>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <v-data-table
          v-if="classStudents && renderComponent"
          :headers="headers2"
          :items="classStudents"
          hide-default-header
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Суралцагчийн мэдээлэл</v-toolbar-title>
            </v-toolbar>
          </template>
          <!-- First Header Row -->
          <template slot="header">
            <tr style="width: 100%">
              <th
                colspan="1"
                class="text-center text-body-2 font-weight-regular"
                style="border: 1px solid #e0e0e0; background-color: #f5f5f5"
              >
                No
              </th>
              <th
                colspan="1"
                class="text-center text-body-2 font-weight-regular"
                style="border: 1px solid #e0e0e0; background-color: #f5f5f5"
              >
                Суралцагч
              </th>
              <th
                colspan="1"
                class="text-center text-body-2 font-weight-regular"
                style="border: 1px solid #e0e0e0; background-color: #f5f5f5"
              >
                Регистр
              </th>
              <th
                colspan="1"
                class="text-center text-body-2 font-weight-regular"
                style="border: 1px solid #e0e0e0; background-color: #f5f5f5"
              >
                Нийт судалсан
              </th>

              <th
                colspan="2"
                class="text-center text-body-2 font-weight-regular"
                style="border: 1px solid #e0e0e0; background-color: #f5f5f5"
              >
                <div
                  class="text-center text-body-2 font-weight-bold"
                  style="border-bottom: 1px solid #e0e0e0"
                >
                  Заавал судлах
                </div>
                <v-row no-gutters justify="space-between" class="px-5">
                  <v-col cols="auto">Бодогдсон</v-col>
                  <v-col cols="auto">Бодогдоогүй</v-col>
                </v-row>
              </th>
              <th
                colspan="2"
                class="text-center text-body-2 font-weight-regular"
                style="border: 1px solid #e0e0e0; background-color: #f5f5f5"
              >
                <div
                  class="text-center text-body-2 font-weight-bold"
                  style="border-bottom: 1px solid #e0e0e0"
                >
                  Сонгон судлах
                </div>

                <v-row no-gutters justify="space-between" class="px-5">
                  <v-col cols="auto">Бодогдсон</v-col>
                  <v-col cols="auto">Бодогдоогүй</v-col>
                </v-row>
              </th>
              <th
                colspan="2"
                class="text-center text-body-2 font-weight-regular"
                style="border: 1px solid #e0e0e0; background-color: #f5f5f5"
              >
                <div
                  class="text-center text-body-2 font-weight-bold"
                  style="border-bottom: 1px solid #e0e0e0"
                >
                  Мэргэжлийн болон гүнзгий
                </div>
                <v-row no-gutters justify="space-between" class="px-5">
                  <v-col cols="auto">Бодогдсон</v-col>
                  <v-col cols="auto">Бодогдоогүй</v-col>
                </v-row>
              </th>
            </tr>
          </template>

          <template v-slot:item.calculated1="{ item }">
            <span class="green--text">{{ item.calculated1 }} </span>
          </template>

          <template v-slot:item.notCalculated1="{ item }">
            <span class="orange--text">{{ item.notCalculated1 }} </span>
          </template>

          <template v-slot:item.calculated2="{ item }">
            <span class="green--text">{{ item.calculated2 }} </span>
          </template>

          <template v-slot:item.notCalculated2="{ item }">
            <span class="orange--text">{{ item.notCalculated2 }} </span>
          </template>

          <template v-slot:item.calculated3="{ item }">
            <span class="green--text">{{ item.calculated3 }} </span>
          </template>

          <template v-slot:item.notCalculated3="{ item }">
            <span class="orange--text">{{ item.notCalculated3 }} </span>
          </template>
        </v-data-table>
      </v-tab-item>

      <v-tab-item>
        <v-data-table
          v-if="planCourses2 && renderComponent"
          :headers="headers3"
          :items="classStudents"
          class="elevation-1"
          dense
          hide-details
          hide-default-header
          :items-per-page="20"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Хичээл</v-toolbar-title>
            </v-toolbar>
          </template>
          <template slot="header">
            <tr style="width: 100%">
              <th
                colspan="1"
                class="text-center text-body-2 font-weight-regular"
                style="border: 1px solid #e0e0e0; background-color: #f5f5f5"
              >
                No
              </th>
              <th
                colspan="1"
                class="text-center text-body-2 font-weight-regular"
                style="border: 1px solid #e0e0e0; background-color: #f5f5f5"
              >
                Суралцагч
              </th>
              <th
                colspan="1"
                class="text-center text-body-2 font-weight-regular"
                style="border: 1px solid #e0e0e0; background-color: #f5f5f5"
              >
                Регистр
              </th>
              <th
                v-for="(group, gindex) of planCourses2"
                :key="'g' + gindex"
                :colspan="group.length"
                class="text-center text-body-2 font-weight-regular"
                style="border: 1px solid #e0e0e0; background-color: #f5f5f5"
              >
                <div
                  class="text-center text-body-2 font-weight-bold"
                  style="border-bottom: 1px solid #e0e0e0"
                >
                  {{ group[0].COURSE_CLASSIFICATION_NAME }}
                </div>

                <tr no-gutters justify="space-between">
                  <th
                    style="white-space: nowrap"
                    class="px-2 text-center text-body-2 font-weight-regular"
                    v-for="(lsn, lindex) of group"
                    :key="'gb' + lindex"
                  >
                    {{ lsn.SUBJECT_AREA_NAME }}
                  </th>
                </tr>
              </th>
            </tr>
          </template>
          <template #item="{ item }">
            <tr>
              <td v-for="(headr, hindex) in headers3" :key="'h' + hindex">
                <div v-if="headr.bgrade">
                  <div v-if="item.grades && item.grades[headr.value]">
                    {{ item.grades[headr.value].gradeMark }}
                  </div>
                  <div v-else></div>
                </div>
                <div>{{ item[headr.value] }}</div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="calSubjectAreaDialog" max-width="80%">
      <v-card>
        <v-card-title>
          <strong>
            {{ selectedClassGroup.STUDENT_GROUP_NAME }} төгсөлт бүртгэл,
            судлагдаxууны бүртгэл
          </strong>
        </v-card-title>

        <v-card-text style="max-height: 1000px; overflow-x: auto">
          <v-row>
            <v-col cols="4">
              <v-card height="600px" style="overflow-y: scroll">
                <v-card-text>
                  <p
                    style="cursor: pointer"
                    @click="_selectCourse(lesson, lIndex)"
                    :class="
                      selectedCourse && selectedCourse.id == lesson.id
                        ? 'yellow pa-2'
                        : 'pa-2'
                    "
                    v-for="(lesson, lIndex) in planCourses"
                    :key="lIndex + lesson.id"
                  >
                    {{ lIndex + 1 }}. {{ lesson.COURSE_NAME }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-if="selectedCourse">
              <h3>
                {{ selectedCourseIndex }}.
                <span class="blue--text">{{ selectedCourse.COURSE_NAME }}</span>
              </h3>
              <v-data-table
                v-if="grades"
                height="570px"
                show-select
                :single-select="false"
                v-model="selectedStudentsForSubjectAreaCalculation"
                fixed-header
                :headers="[
                  { text: 'No.', value: 'index', align: 'start', width: '5%' },
                  { text: 'Нэр', value: 'name', align: 'start', width: '25%' },
                  {
                    text: 'Голч',
                    value: 'subjectAreaFinalScore',
                    align: 'start',
                  },
                  {
                    text: 'Огноо',
                    value: 'subjectAreaFinalScoreDate',
                    align: 'start',
                  },
                  {
                    text: 'Төлөв',
                    value: 'subjectAreaFinalScoreState',
                    align: 'start',
                  },
                  {
                    text: 'Дүнгүүд',
                    value: 'grades',
                    align: 'start',
                  },
                ]"
                :items="classStudents"
                dense
                hide-default-footer
                :items-per-page="-1"
              >
                <template v-slot:item.subjectAreaFinalScoreState="{ item }">
                  <span
                    :class="item.isUsingBGrade ? 'green--text' : 'red--text'"
                    >{{
                      item.isUsingBGrade ? "Дүн бодогдсон" : "Дүн бодогдоогүй"
                    }}
                  </span>
                </template>
                <template v-slot:item.grades="{ item }">
                  <span :class="item.isUsingBGrade ? 'green--text' : ''">{{
                    item.isUsingBGrade
                      ? getGrades(item, true)
                      : getGrades(item, false)
                  }}</span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            class="bg-gradient-danger mr-2"
            dark
            text
            @click="calSubjectAreaDialog = false"
            >Устгаx</v-btn
          >

          <v-btn
            class="bg-gradient-success"
            dark
            text
            @click="_calculateSubjectAreaGrades()"
            >Дүн бодоx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
const fb = require("@/firebaseConfig.js");

export default {
  data() {
    return {
      selectedCourseIndex: null,
      selectedCourse: null,
      selected: [],
      calSubjectAreaDialog: false,
      planCourses: null,
      selectedTab: 0,
      headers: [
        { text: "No", value: "index", align: "start" },
        { text: "Хичээл", value: "SUBJECT_AREA_NAME" },
        { text: "Төрөл", value: "COURSE_CLASSIFICATION_NAME" },
        // { text: "Нийт судалсан", value: "totalStudied" },
        { text: "Дүн бодогдсон", value: "withGrade" },
        { text: "Дүн бодогдоогүй", value: "withNoGrade" },
        // { text: "Хянагдаж байгаа", value: "underReview" },
        // { text: "Дүн цуцлагдсан", value: "gradeCancelled" },
      ],
      renderComponent: true,
      // courses: [
      //   {
      //     name: "Монгол хэл 12",
      //     type: "Заавал",
      //     totalStudied: 0,
      //     gradeApproved: 0,
      //     gradeRegistered: 0,
      //     underReview: 0,
      //     gradeCancelled: 0,
      //   },
      //   {
      //     name: "Үндэсний бичиг 12",
      //     type: "Заавал",
      //     totalStudied: 0,
      //     gradeApproved: 0,
      //     gradeRegistered: 0,
      //     underReview: 0,
      //     gradeCancelled: 0,
      //   },
      //   {
      //     name: "Уран зохиол 12",
      //     type: "Заавал",
      //     totalStudied: 0,
      //     gradeApproved: 0,
      //     gradeRegistered: 0,
      //     underReview: 0,
      //     gradeCancelled: 0,
      //   },
      //   {
      //     name: "Математик 12",
      //     type: "Заавал",
      //     totalStudied: 0,
      //     gradeApproved: 0,
      //     gradeRegistered: 0,
      //     underReview: 0,
      //     gradeCancelled: 0,
      //   },
      //   {
      //     name: "Мэдээллийн технологи 12",
      //     type: "Заавал",
      //     totalStudied: 0,
      //     gradeApproved: 0,
      //     gradeRegistered: 0,
      //     underReview: 0,
      //     gradeCancelled: 0,
      //   },
      //   {
      //     name: "Англи хэл 12",
      //     type: "Заавал",
      //     totalStudied: 0,
      //     gradeApproved: 0,
      //     gradeRegistered: 0,
      //     underReview: 0,
      //     gradeCancelled: 0,
      //   },
      //   {
      //     name: "Орос хэл 12",
      //     type: "Заавал",
      //     totalStudied: 0,
      //     gradeApproved: 0,
      //     gradeRegistered: 0,
      //     underReview: 0,
      //     gradeCancelled: 0,
      //   },
      //   {
      //     name: "Биеийн тамир 12",
      //     type: "Заавал",
      //     totalStudied: 0,
      //     gradeApproved: 0,
      //     gradeRegistered: 0,
      //     underReview: 0,
      //     gradeCancelled: 0,
      //   },
      //   {
      //     name: "Эрүүл мэнд 12",
      //     type: "Заавал",
      //     totalStudied: 0,
      //     gradeApproved: 0,
      //     gradeRegistered: 0,
      //     underReview: 0,
      //     gradeCancelled: 0,
      //   },
      //   {
      //     name: "Дизайн/зураг зүй, технологи 12",
      //     type: "Заавал",
      //     totalStudied: 0,
      //     gradeApproved: 0,
      //     gradeRegistered: 0,
      //     underReview: 0,
      //     gradeCancelled: 0,
      //   },
      // ],

      headers2: [
        { text: "No", value: "index", align: "start" },
        { text: "Суралцагч", value: "name", align: "start" },
        { text: "Регистр", value: "REGISTER" },
        { text: "Нийт судалсан", value: "totalStudied" },
        { text: "Бодогдсон", value: "calculated1" },
        { text: "Бодогдоогүй", value: "notCalculated1" },
        { text: "Бодогдсон", value: "calculated2" },
        { text: "Бодогдоогүй", value: "notCalculated2" },
        { text: "Бодогдсон", value: "calculated3" },
        { text: "Бодогдоогүй", value: "notCalculated3" },
      ],
      students: [
        {
          student: "Н.Бархасвад",
          register: "ме07322714",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "М.Ванчир-Эрдэнэ",
          register: "ме07241811",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Б.Гансух",
          register: "ру07272316",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "У.Жавхлан",
          register: "тя07252311",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Э.Мичидмаа",
          register: "ме07231700",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Д.Мягмарсүх",
          register: "ме07280709",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Т.Мөнхтулга",
          register: "ме07312717",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Б.Мөнхцэцэг",
          register: "ме07292605",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Н.Мөрөн",
          register: "ме07292514",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
        {
          student: "Э.Нандин-Эрдэнэ",
          register: "ме07222604",
          totalStudied: 91,
          calculated1: 0,
          notCalculated1: 17,
          calculated2: 0,
          notCalculated2: 38,
          calculated3: 0,
          notCalculated3: 17,
        },
      ],
      courses: null,
      loading: false,
      grades: null,
      headers3: null,
      planCourses2: null,
      selectedStudentsForSubjectAreaCalculation: [],
    };
  },
  watch: {
    calSubjectAreaDialog() {
      this.selectedStudentsForSubjectAreaCalculation = [];
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
  },
  props: {
    selectedClassGroup: {
      type: Object,
      required: true,
    },
    classStudents: {
      type: Array,
      required: true,
    },
  },
  methods: {
    _calculateSubjectAreaGrades() {
      // this.selectedCourse
      this.selectedStudentsForSubjectAreaCalculation.forEach((stud) => {
        console.log(stud);
        let grades = this.grades.filter(
          (g) =>
            g.PERSON_ID == stud.PERSON_ID &&
            g.subjectAreaId == this.selectedCourse.SUBJECT_AREA_ID &&
            g.courseClassification == this.selectedCourse.COURSE_CLASSIFICATION
        );
        grades.sort(
          (a, b) => Number(a.academicLevel) - Number(b.academicLevel)
        );

        var foundbGrade = this.bgrades.find(
          (g) => g.PERSON_ID == stud.PERSON_ID
        );

        if (typeof grades != "string" && grades.length > 0) {
          var tmp = Object.assign({}, grades[grades.length - 1]);
          if (foundbGrade) {
            foundbGrade.grades[
              this.selectedCourse.SUBJECT_AREA_ID +
                "-" +
                this.selectedCourse.COURSE_CLASSIFICATION
            ] = tmp;
          } else {
            foundbGrade = {
              PERSON_ID: stud.PERSON_ID,
              grades: {},
              createdAt: new Date(),
            };
            foundbGrade.grades[
              this.selectedCourse.SUBJECT_AREA_ID +
                "-" +
                this.selectedCourse.COURSE_CLASSIFICATION
            ] = tmp;
          }

          this.userData.school.ref
            .collection("b-form")
            .doc(String(stud.PERSON_ID))
            .set(foundbGrade, { merge: true });
        }
      });
      this.calSubjectAreaDialog = false;

      this.$swal.fire("Амжилттай хадгалагдсан!");
    },
    getGrades(item, beingUsed) {
      if (this.grades) {
        let grades = this.grades.filter(
          (g) =>
            g.PERSON_ID == item.PERSON_ID &&
            g.subjectAreaId == this.selectedCourse.SUBJECT_AREA_ID &&
            g.courseClassification == this.selectedCourse.COURSE_CLASSIFICATION
        );
        grades.sort(
          (a, b) => Number(a.academicLevel) - Number(b.academicLevel)
        );
        if (grades.length > 0) {
          if (beingUsed) {
            return grades.map((g) => g.gradeMark)[grades.length - 1];
          } else {
            return grades.map((g) => g.gradeMark).join(", ");
          }
        } else {
          return "-";
        }
      }
    },
    _selectCourse(course, index) {
      this.selectedCourse = course;
      this.selectedCourseIndex = index;

      this.classStudents.forEach((stud) => {
        var foundGrade = this.bgrades.find(
          (g) =>
            g.PERSON_ID == stud.PERSON_ID &&
            g.grades[
              this.selectedCourse.SUBJECT_AREA_ID +
                "-" +
                this.selectedCourse.COURSE_CLASSIFICATION
            ]
        );
        if (foundGrade) {
          stud.isUsingBGrade = true;
        }
      });
    },
    toggleSelect(item) {
      const index = this.selected.findIndex((i) => i.id === item.id);
      if (index >= 0) {
        this.selected.splice(index, 1); // already selected, unselect
      } else {
        this.selected.push(item); // select
      }
    },
    _calculateSubjectAreas(onClick) {
      this.loading = true;
      this.selectedClassGroup.selectedCurriculumPlan.ref
        .collection("courses")
        .get()
        .then((docs) => {
          this.planCourses = [];
          this.planCourses2 = null;
          this.headers3 = [
            {
              text: "No",
              value: "index",
              align: "start",
            },
            { text: "Суралцагч", value: "name", align: "start" },
            { text: "Регистр", value: "REGISTER" },
          ];

          docs.forEach((doc) => {
            let course = doc.data();
            course.ref = doc.ref;
            course.id = doc.id;
            course.COURSE_CLASSIFICATION_NAME =
              course.COURSE_CLASSIFICATION_NAME.replace(
                "судлах хичээл",
                ""
              ).replace("хичээл", "");

            this.planCourses.push(course);
          });
          this.planCourses = this.planCourses
            .sort((a, b) => a.SUBJECT_AREA_NAME - b.SUBJECT_AREA_NAME)
            .sort((a, b) => a.SUBJECT_AREA_ID - b.SUBJECT_AREA_ID)
            .sort((a, b) => a.COURSE_CLASSIFICATION - b.COURSE_CLASSIFICATION);
          this.loading = false;

          var index = 1;
          this.planCourses.forEach((c) => {
            c.index = index;
            index++;
            var grades = this.bgrades.filter(
              (grade) =>
                grade.subjectAreaId == c.SUBJECT_AREA_ID &&
                grade.courseClassification == c.COURSE_CLASSIFICATION
            );

            c.withGrade = grades.length;
            c.withNoGrade = this.classStudents.length - grades.length;

            this.headers3.push({
              text: c.SUBJECT_AREA_NAME,
              value: `${c.SUBJECT_AREA_ID}-${c.COURSE_CLASSIFICATION}`,
              bgrade: true,
              align: "start",
            });
            console.log({
              text: c.SUBJECT_AREA_NAME,
              value: `${c.SUBJECT_AREA_ID}-${c.COURSE_CLASSIFICATION}`,
              align: "start",
            });
          });

          this.planCourses2 = Object.values(
            this.planCourses.reduce((groups, course) => {
              const classification = course.COURSE_CLASSIFICATION;
              if (!groups[classification]) {
                groups[classification] = [];
              }
              groups[classification].push(course);
              return groups;
            }, {})
          );
          if (onClick) this.calSubjectAreaDialog = true;
        });
    },
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
    _setupp() {
      this.loading = true;

      this._calculateSubjectAreas();

      // console.log(this.classStudents);

      const chunkSize = 10;
      const studentChunks = [];
      for (let i = 0; i < this.classStudents.length; i += chunkSize) {
        studentChunks.push(this.classStudents.slice(i, i + chunkSize));
      }
      console.log(studentChunks);

      this.grades = [];
      this.bgrades = [];
      const ACADEMIC_LEVEL = ["10", "11", "12"];
      ACADEMIC_LEVEL.forEach((level) => {
        studentChunks.forEach((chunk) => {
          fb.db
            .collectionGroup("final-scores")
            .where("academicLevel", "==", level)
            .where(
              "PERSON_ID",
              "in",
              chunk.map((ss) => String(ss.PERSON_ID))
            )
            .get()
            .then((docs) => {
              console.log(docs.size);
              docs.forEach((doc) => {
                let grade = doc.data();
                grade.ref = doc.ref;
                grade.id = doc.id;
                this.grades.push(grade);
              });
            });
        });
      });

      setTimeout(() => {
        this.classStudents.forEach((stud) => {
          stud.totalStudied = this.planCourses.filter(
            (c) =>
              String(c.COURSE_CLASSIFICATION) == "1" ||
              String(c.COURSE_CLASSIFICATION) == "2" ||
              String(c.COURSE_CLASSIFICATION) == "3"
          ).length;
          stud.calculated1 = 0;
          stud.calculated2 = 0;
          stud.calculated3 = 0;
          stud.notCalculated1 = this.planCourses.filter(
            (c) => String(c.COURSE_CLASSIFICATION) == "1"
          ).length;
          stud.notCalculated2 = this.planCourses.filter(
            (c) => String(c.COURSE_CLASSIFICATION) == "2"
          ).length;
          stud.notCalculated3 = this.planCourses.filter(
            (c) => String(c.COURSE_CLASSIFICATION) == "3"
          ).length;
          this.forceRerender();
        });
      }, 500);

      studentChunks.forEach((chunk) => {
        fb.db
          .collectionGroup("b-form")
          .where(
            "PERSON_ID",
            "in",
            chunk.map((ss) => String(ss.PERSON_ID))
          )
          .get()
          .then((docs) => {
            console.log(docs.size);
            docs.forEach((doc) => {
              let grade = doc.data();
              grade.ref = doc.ref;
              grade.id = doc.id;

              var foundStud = this.classStudents.find(
                (stud) => String(stud.PERSON_ID) == String(grade.PERSON_ID)
              );

              for (var courseKey in grade.grades) {
                if (grade.grades[courseKey].courseClassification == "1") {
                  foundStud.calculated1++;
                  foundStud.notCalculated1--;
                } else if (
                  grade.grades[courseKey].courseClassification == "2"
                ) {
                  foundStud.calculated2++;
                  foundStud.notCalculated2--;
                } else if (
                  grade.grades[courseKey].courseClassification == "3"
                ) {
                  foundStud.calculated3++;
                  foundStud.notCalculated3--;
                }
              }

              foundStud.grades = grade.grades;
              console.log(foundStud);
              this.forceRerender();

              this.bgrades.push(grade);
            });
          });
      });

      this.userData.school.ref
        .collection("lessons-" + this.userData.school.currentYear)
        .where("classGroupRefs", "array-contains", this.selectedClassGroup.ref)
        .orderBy("courseInfo.COURSE_NAME", "asc")
        .onSnapshot((docs) => {
          this.courses = [];
          docs.forEach(async (doc) => {
            let lesson = doc.data();
            lesson.ref = doc.ref;
            lesson.id = doc.id;

            if (!lesson.deleted) {
              lesson.courseInfo.ENROLLMENT_CATEGORY_NAME =
                lesson.courseInfo.ENROLLMENT_CATEGORY_NAME.replace(
                  "судлах",
                  ""
                );

              if (
                this.courses.find(
                  (course) =>
                    course.SUBJECT_AREA_ID == lesson.courseInfo.SUBJECT_AREA_ID
                ) == undefined
              )
                this.courses.push(lesson.courseInfo);
            }
          });

          this.courses = this.courses
            .sort((a, b) => a.SUBJECT_AREA_ID - b.SUBJECT_AREA_ID)
            .sort(
              (a, b) =>
                b.ENROLLMENT_CATEGORY.length - a.ENROLLMENT_CATEGORY.length
            );
          this.loading = false;

          var index = 1;
          this.courses.forEach((lsn) => {
            lsn.index = index;
            index++;
          });
        });
    },
  },
  created() {
    this._setupp();
  },
};
</script>
